import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import './Form.scss';

function Form(props) {
  const { t } = useTranslation();
  const [alert, setAlert] = useState(false);
  const [boxAlert, setBoxAlert] = useState(false);
  const noteRef = useRef(null);
  const phoneRef = useRef(null);

  useEffect(() => {
    const handlePopstate = function () {
      if (window.localStorage.getItem('pageStatus') === 'main') {
        noteRef.current.blur();
        phoneRef.current.blur();
      }
    };

    window.addEventListener('popstate', handlePopstate);

    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  useEffect(() => {
    if (props.callTaxifail !== '') {
      setAlert(true);
      isTel(props.orderDetail.phone) ? setBoxAlert(false) : setBoxAlert(true);
    }
  }, [props.callTaxifail, props.orderDetail.phone]);

  function isTel(str) {
    let reg2 = /(^09\d{2}-?\d{3}-?\d{3}$)|(^((\+886)|(886))\s?(9)\d{2}\s?\d{3}\s?\d{3}$)/;
    if (str.length < 10 || str.length > 18) {
      return false;
    } else {
      return reg2.exec(str);
    }
  }

  function inputOnChange(e) {
    let input = e.target.value;
    props.setOrderDetail((orderDetail) => ({
      ...orderDetail,
      phone: input,
    }));
    if (isTel(input)) {
      props.setOrderDetail((orderDetail) => ({
        ...orderDetail,
        ok: true,
        errMsg: '',
      }));
      alert && setBoxAlert(false);
    } else {
      props.setOrderDetail((orderDetail) => ({
        ...orderDetail,
        ok: false,
        errMsg: input ? 'type' : 'empty',
      }));
      alert && setBoxAlert(true);
    }
  }

  function textareaOnChange(e) {
    let input = e.target.value;
    props.setOrderDetail((orderDetail) => ({
      ...orderDetail,
      comment: input,
    }));
  }

  return (
    <div className={`form ${props.formDisplay ? 'inActive' : 'active'}`}>
      <div className="form__body">
        <div>
          <div className="formContainer">
            <span>
              {t('A021')}
              <span style={{ color: '#F05151', fontSize: '1.6rem' }}>*</span>
            </span>
            <div
              className="formContainer__box"
              style={boxAlert ? { border: '1px solid #f05151' } : null}
            >
              <input
                ref={phoneRef}
                type="tel"
                pattern="[0]{1}[0-9]{9}"
                maxLength="20"
                required
                placeholder={t('A022')}
                value={props.orderDetail ? props.orderDetail.phone : ''}
                onChange={(e) => inputOnChange(e)}
              />
            </div>
          </div>

          <div className="formContainer high-block">
            <span>{t('A027')}</span>
            <div className="formContainer__textarea">
              <textarea
                ref={noteRef}
                placeholder={t('A028')}
                onChange={textareaOnChange}
                value={props.orderDetail ? props.orderDetail.comment : ''}
                maxLength="50"
              />
            </div>
          </div>
          <div className="formContainer reminder">
            <span>
              溫馨提醒：
              <br />
              一、若需車資收據請於行程結束後至行程記錄填寫信箱資訊以收取電子收據
              <br />
              {!props.isOnlinePay && '三、如需車資收據請於下車時向司機提出'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Form;
